import React from 'react';
import {ThemeProvider} from '@rn-vui/themed';

import {AppRoute} from '../../models/AppRoute';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import rewardsTheme from '../../theme/rewardsTheme';

import WishlistScreenLoyaltyEnabled from './WishlistScreenLoyaltyEnabled';

export default (props: RouteNavigatorScreenProps<AppRoute.WISHLIST>) => (
  <ThemeProvider theme={rewardsTheme}>
    <WishlistScreenLoyaltyEnabled {...props} />
  </ThemeProvider>
);
